import React from 'react';
import { caseStudies } from '../data/mock';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { Gallery4 } from './blocks/gallery4';

const CaseStudies = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const galleryItems = caseStudies.map((study, index) => ({
    id: study.id,
    title: study.title,
    description: study.description,
    href: study.link,
    image:
      study.image ||
      [
        'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1600&q=80',
        'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80',
        'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1600&q=80',
        'https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=1600&q=80'
      ][index % 4],
    category: study.category,
    isNew: study.isNew,
    client: study.client
  }));

  if (!galleryItems.length) return null;

  return (
    <section id="case-studies" className="relative py-20 sm:py-24 lg:py-32 bg-[--bg-primary]">
      <div className="absolute top-0 left-0 right-0 section-divider" />
      
      <div ref={sectionRef} className="max-w-[1500px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div 
          className={`mb-16 max-w-5xl transition-all duration-700 ease-out ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <p className="section-eyebrow mb-4">Case Studies</p>
          <h2 className="text-[clamp(2rem,4.1vw,3.8rem)] font-semibold text-[--text-primary] leading-[1.02]">
            Real outcomes from
            <br />
            <span className="accent-wash">real operating teams.</span>
          </h2>

        </div>

        <div
          className={`transition-all duration-700 ease-out delay-150 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <Gallery4 items={galleryItems} />
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
